import { useList } from '../../../api/react-query';
import { useApp } from '../../../context';

export function useListAccrualLeaves({ props = {} }) {
  const { rowsPerPage } = useApp();

  const { data, isLoading, isRefetching, isFetching, refetch } = useList(
    'accrual/leaveTypes',
    { ...props },
  );

  return {
    accrualLeaves: data?.data?.data || [],
    count: data?.data?.count,
    accruallLeaveLoading: isLoading || isRefetching || isFetching,
    refetch,
  };
}
